import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ba77a60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title w-full pb-2" }, "お問合せ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "intro w-full" }, [
  /*#__PURE__*/_createElementVNode("p", null, "サービスについてのお問合せは2日目安にご返信いたします。")
], -1))
const _hoisted_4 = { class: "content mt-3" }
const _hoisted_5 = { class: "col-12 py-0" }
const _hoisted_6 = { class: "list-none m-0 p-0" }
const _hoisted_7 = { class: "field col-12 md:col-5" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "subject",
  class: "flex font-normal"
}, [
  /*#__PURE__*/_createTextVNode("件名 "),
  /*#__PURE__*/_createElementVNode("span", { class: "pl-1 text-red" }, "必須")
], -1))
const _hoisted_9 = { class: "field col-12 md:col-5 mt-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "flex font-normal"
}, [
  /*#__PURE__*/_createTextVNode("担当者名 "),
  /*#__PURE__*/_createElementVNode("span", { class: "pl-1 text-red" }, "必須")
], -1))
const _hoisted_11 = { class: "field col-12 md:col-3 mt-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "phone_number",
  class: "flex font-normal"
}, [
  /*#__PURE__*/_createTextVNode("電話番号 "),
  /*#__PURE__*/_createElementVNode("span", { class: "pl-1 text-red" }, "必須")
], -1))
const _hoisted_13 = { class: "field col-12 md:col-5 mt-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "flex font-normal"
}, [
  /*#__PURE__*/_createTextVNode("メールアドレス "),
  /*#__PURE__*/_createElementVNode("span", { class: "pl-1 text-red" }, "必須")
], -1))
const _hoisted_15 = { class: "col-12 md:col-6 mt-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "content",
  class: "flex font-normal"
}, [
  /*#__PURE__*/_createTextVNode("お問合せ内容 "),
  /*#__PURE__*/_createElementVNode("span", { class: "pl-1 text-red" }, "必須")
], -1))
const _hoisted_17 = { class: "col-12 md:col-6 flex justify-content-end" }

import { ref, reactive, computed } from "vue";
import InputText from "primevue/inputtext";
import Textarea from "primevue/textarea";
import Button from "primevue/button";
import Message from "@/clinic/components/atoms/CustomPrimeVue/Message.vue";

import rules from "../rules";
import { get, set } from "@vueuse/core";
import { ApiContactRequest } from "../../../typings";
import { useAsyncValidator } from "@vueuse/integrations/useAsyncValidator";
import { ValidateError } from "async-validator";


export default /*#__PURE__*/_defineComponent({
  __name: 'form',
  emits: ["confirm"],
  setup(__props, { emit: emits }) {



const formContact: ApiContactRequest = reactive<ApiContactRequest>({
  subject: "",
  name: "",
  phone_number: "",
  email: "",
  content: "",
});

const initValidation = computed(() => {
  return useAsyncValidator(formContact, rules);
});
const validate = async (): Promise<boolean> => {
  const { execute } = get(initValidation);
  const { pass: fPass, errorFields: fErrorFields, errors: fErrors } = await execute();
  set(pass, get(fPass));
  set(errorFields, get(fErrorFields));
  set(errors, get(fErrors));
  return get(pass) as boolean;
};
const pass = ref(false);
const errorFields = ref<{ [key: string]: ValidateError | ValidateError[] }>();
const errors = ref<ValidateError[]>([]);

const onClickConfirm = async () => {
  if (!(await validate())) {
    return;
  }
  emits("confirm", formContact);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("form", null, [
        _createElementVNode("div", _hoisted_5, [
          (!pass.value && errors.value?.length)
            ? (_openBlock(), _createBlock(Message, {
                key: 0,
                icon: "false",
                closable: false,
                severity: "error",
                sticky: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("ul", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "pb-2",
                        key: index
                      }, _toDisplayString(error?.message), 1))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_unref(InputText), {
            class: _normalizeClass(["flex border-round-md", { 'p-invalid': errorFields.value?.subject }]),
            placeholder: "プレスホルダーテキスト",
            modelValue: formContact.subject,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formContact.subject) = $event))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_unref(InputText), {
            class: _normalizeClass(["flex border-round-md", { 'p-invalid': errorFields.value?.name }]),
            placeholder: "プレスホルダーテキスト",
            modelValue: formContact.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formContact.name) = $event))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_unref(InputText), {
            class: _normalizeClass(["flex border-round-md", { 'p-invalid': errorFields.value?.phone_number }]),
            placeholder: "プレスホルダーテキスト",
            modelValue: formContact.phone_number,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formContact.phone_number) = $event))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_unref(InputText), {
            class: _normalizeClass(["flex border-round-md", { 'p-invalid': errorFields.value?.email }]),
            placeholder: "プレスホルダーテキスト",
            modelValue: formContact.email,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formContact.email) = $event))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(_unref(Textarea), {
            class: _normalizeClass(["w-100 h-12rem mt-2", { 'p-invalid': errorFields.value?.content }]),
            modelValue: formContact.content,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formContact.content) = $event)),
            placeholder: "お問合せ内容について、詳細の記載をお願いいたします",
            rows: "5",
            cols: "30"
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_unref(Button), {
            label: "送信 内容を確認する",
            onClick: onClickConfirm
          })
        ])
      ])
    ])
  ]))
}
}

})